export default __webpack_public_path__ + "static/media/fermer.d3413ce7.png";